/* template */
<template><div :style="[(customStyle)] | transRpxStyle" class="descriptions-wrap"><div class="descriptions-title" v-if="(title)">{{ title }}</div><div class="descriptions-main"><slot/></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mf02c563e"}'>
.descriptions-wrap {
  padding: 12px 24px;
  background: #ffffff;

  .descriptions-title {
    line-height: 22px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f2f7;
    margin-bottom: 12px;
    font-size: 16px;
    color: #000000;
    font-weight: 700;
  }
}
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mf02c563e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexf02c563e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexf02c563e%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mf02c563e"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexf02c563e/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
